import { InteractionScoringDto } from '../../coaching-base/general';
import { CmpsFormField, CmpsFormFields } from '../experimental.form';
import { InteractionScoringModel } from '../observation/observation.model';

import { EffortDemonstrated } from './effort-demonstrated.model';
import { ScoreFormValue } from './score-form-value.model';

export interface ScoreFormFields extends CmpsFormFields {
    TRACKING_ID: CmpsFormField;
    TRACKING_CHANGED: CmpsFormField;
    INTERACTION_SCORING_ID: CmpsFormField;
    INTERACTION_ID: CmpsFormField;
    FOCUS_DELIVERED: CmpsFormField;
    OPP_TO_DEMONSTRATE: CmpsFormField;
    WILLINGNESS_TRY: CmpsFormField;
    PROFICIENCY_DELIVERED: CmpsFormField;
    CONSISTENCY_DELIVERED: CmpsFormField;
    CONFIDENCE_DELIVERED: CmpsFormField;
    SCORE_CONFIGURATION_ID: CmpsFormField;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScoreFormFields: ScoreFormFields = {
    TRACKING_ID: {
        name: 'trackingId',
        label: undefined,
    },
    TRACKING_CHANGED: {
        name: 'trackingChanged',
        label: undefined,
    },
    INTERACTION_SCORING_ID: {
        name: 'interactionScoringId',
        label: '',
    },
    INTERACTION_ID: {
        name: 'interactionId',
        label: '',
    },
    FOCUS_DELIVERED: {
        name: 'focusDelivered',
        label: '',
    },
    OPP_TO_DEMONSTRATE: {
        name: 'opportunityToDemonstrate',
        label: '',
    },
    WILLINGNESS_TRY: {
        name: 'willingnessToTry',
        label: '',
    },
    PROFICIENCY_DELIVERED: {
        name: 'proficiencyDelivered',
        label: '',
    },
    CONSISTENCY_DELIVERED: {
        name: 'consistencyDelivered',
        label: '',
    },
    CONFIDENCE_DELIVERED: {
        name: 'confidenceDelivered',
        label: '',
    },
    SCORE_CONFIGURATION_ID: {
        name: 'scoringConfigurationId',
        label: '',
    },
};

export function createScore(currentScoringConfigId?: number): ScoreFormValue {
    return {
        trackingId: Math.random(),
        trackingChanged: false,
        interactionScoringId: undefined,
        interactionId: undefined,
        focusDelivered: EffortDemonstrated.NA,
        opportunityToDemonstrate: null,
        willingnessToTry: null,
        proficiencyDelivered: null,
        consistencyDelivered: 0,
        confidenceDelivered: 0,
        scoringConfigurationId: currentScoringConfigId,
    };
}

// TODO move?
export function scoreFormValueTransformer(
    model: InteractionScoringDto,
): ScoreFormValue {
    if (!model) {
        return null;
    }
    return {
        scoringConfigurationId: model.scoringConfigurationId,
        trackingId: Math.random(),
        trackingChanged: false,
        interactionScoringId: model.interactionScoringId,
        interactionId: model.interactionId,
        focusDelivered: model.focusDelivered,
        opportunityToDemonstrate: model.opportunityToDemonstrate,
        willingnessToTry: model.willingnessToTry,
        proficiencyDelivered:
            model.proficiencyDelivered != null
                ? model.proficiencyDelivered
                : null, // 'cause of ui slider. see composeObservation
        consistencyDelivered:
            model.consistencyDelivered != null ? model.consistencyDelivered : 0, // 'cause of ui slider. see composeObservation
        confidenceDelivered:
            model.confidenceDelivered != null ? model.confidenceDelivered : 0, // 'cause of ui slider. see composeObservation
    };
}

// TODO move?
export function scoreFormValueReverseTransformer(
    model: ScoreFormValue,
): InteractionScoringModel {
    return {
        scoringConfigurationId: model.scoringConfigurationId,
        interactionScoringId: model.interactionScoringId,
        interactionId: model.interactionId,
        focusDelivered: model.focusDelivered,
        opportunityToDemonstrate: model.opportunityToDemonstrate,
        willingnessToTry: model.willingnessToTry,
        proficiencyDelivered:
            model.proficiencyDelivered !== 0
                ? model.proficiencyDelivered
                : null, // 'cause of ui slider. see composeObservation
        consistencyDelivered:
            model.consistencyDelivered !== 0
                ? model.consistencyDelivered
                : null, // 'cause of ui slider. see composeObservation
        confidenceDelivered:
            model.confidenceDelivered !== 0 ? model.confidenceDelivered : null, // 'cause of ui slider. see composeObservation
        focusId: null,
        notes: null,
        behaviour: null,
        subBehaviour: null,
        metricId: null,
        queueId: null,
    };
}
